import { gql } from '@apollo/client'
import { PICTURES_LIST } from 'requests/fragments/picture'

gql`
  type FileInput {
    name: String!
    type: String!
    size: Int!
    path: String!
  }

  type FileConversionOptionsFormatInput {
    name: string!
  }

  type FileConversionOptionsInput {
    format: FileConversionOptionsFormatInput
  }
`

export const UPLOAD_FILE_CLOUDINARY = gql`
  mutation uploadFileCloudinary($files: FileInput!) {
    uploadFileCloudinary(files: $files) @client {
      ...PicturesList
    }
  }
  ${PICTURES_LIST}
`

export const UPLOAD_FILE_SIGNED_URL = gql`
  mutation uploadFileSigned($files: FileInput!) {
    uploadFileSigned(files: $files) @client {
      files {
        fileId
        name
        url
      }
    }
  }
`

export const UPLOAD_IMAGE_FILE = gql`
  mutation uploadImageFile($files: FileInput!, $options: FileConversionOptionsInput) {
    uploadImageFile(files: $files, options: $options) @client {
      files {
        fileId
        name
        url
      }
    }
  }
`
